var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragAndDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12844",
    "data-name": "Rectangle 12844",
    width: 31,
    height: 31,
    transform: "translate(493 305)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddddf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.946,
    y1: 1.148,
    x2: 0.139,
    y2: 0.313,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.79,
    y1: 1.358,
    x2: 0.206,
    y2: 0.312,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea5455"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1372",
    "data-name": "Mask Group 1372",
    transform: "translate(-493 -305)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo",
    transform: "translate(493 305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21363",
    "data-name": "Path 21363",
    d: "M31,6.646V24.354a6.462,6.462,0,0,1-.688,2.906l-3.739-4.107-3.09-3.391a3.043,3.043,0,0,0-3.129-1.143,20.935,20.935,0,0,0-3.187,2.257L14.531,17.97a3.575,3.575,0,0,0-5.3,0l-4.8,5.28L.717,27.357a6.491,6.491,0,0,1-.717-3V6.646A6.646,6.646,0,0,1,6.646,0H24.354A6.646,6.646,0,0,1,31,6.646Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21364",
    "data-name": "Path 21364",
    d: "M30.312,27.28a6.626,6.626,0,0,1-4.156,3.478L19.375,23.25l-2.16-2.373a20.935,20.935,0,0,1,3.129-2.257,3.031,3.031,0,0,1,3.129,1.143l3.09,3.41Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21365",
    "data-name": "Path 21365",
    d: "M26.156,30.758A6.723,6.723,0,0,1,24.374,31H6.646A6.636,6.636,0,0,1,.717,27.357l3.71-4.107,4.8-5.27a3.575,3.575,0,0,1,5.3,0l2.635,2.906,2.16,2.364Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21366",
    "data-name": "Path 21366",
    d: "M26.156,30.758A6.723,6.723,0,0,1,24.374,31H6.646A6.636,6.636,0,0,1,.717,27.357l3.71-4.107,4.8-5.27a3.575,3.575,0,0,1,5.3,0l2.635,2.906,2.16,2.364Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_715",
    "data-name": "Ellipse 715",
    cx: 2.218,
    cy: 2.218,
    r: 2.218,
    transform: "translate(18.813 7.75)",
    fill: "url(#linear-gradient-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/dragAndDrop.e68a1d38fd45232237f476877f1a9d20.svg";
export { ForwardRef as ReactComponent };